import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { getAuth, signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { addUser, emptyCart } from "../../store/actions/action";
import MyAccount from "../../components/MyAccountPopup/MyAccountFixed";
import NotificationBell from "../../components/NotificationBell";
import "./style.css";

const menus = [
  { id: 1, title: "Acasă", link: "/" },
  { id: 3, title: "Evenimente", link: "/evenimente" },
  { id: 6, title: "Consultanță", link: "/consultanta" },
  { id: 4, title: "Mostre Gratuite", link: "/evenimente/mostre" },
];

const PloomNavbar = (props) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const { user } = props.user || {};
  const isAdmin =
    user?.email === process.env.REACT_APP_ADMIN ||
    user?.email === process.env.REACT_APP_ARI_ADMIN;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // toast.success(user?.email + " successfully logged out!");
        props.addUser([]);
        props.emptyCart();
      })
      .catch((error) => toast.error(error.message));
  };

  const closeMenu = () => setMenuOpen(false);

  const handleWhatsApp = () => {
    const message = encodeURIComponent("Bună, Ariana!\nNumele meu este: ");
    window.open(
      `https://wa.me/40743222996?text=${message}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <header
        className={`new-navbar ${scrolled ? "new-navbar--scrolled" : ""}`}
      >
        <div className="new-navbar__inner">
          <Link
            to="/"
            className="new-navbar__logo"
            onClick={() => window.scrollTo(0, 0)}
          >
            <img src="/logo/logo ploom.png" alt="The Oils Babe" />
          </Link>

          <nav className="new-navbar__nav-desktop">
            <ul>
              {menus.map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.link}
                    className={pathname === item.link ? "active" : ""}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="new-navbar__actions">
            <div className="new-navbar__icons-desktop">
              {isAdmin && (
                <div className="new-navbar__icon-wrap">
                  <NotificationBell />
                </div>
              )}
              <div className="new-navbar__icon-wrap">
                <MyAccount logout={handleLogout} color="#904d71" />
              </div>
            </div>

            <button
              className={`new-navbar__hamburger ${menuOpen ? "open" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu — drops down from top, compact */}
      <div
        className={`new-mobile-overlay ${menuOpen ? "new-mobile-overlay--open" : ""}`}
        onClick={closeMenu}
      >
        <div
          className={`new-mobile-menu ${menuOpen ? "new-mobile-menu--open" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="new-mobile-menu__header">
            <Link to="/" onClick={closeMenu}>
              <img src="/logo/logo ploom.png" alt="The Oils Babe" />
            </Link>
            <div className="new-mobile-menu__header-actions">
              {isAdmin && (
                <div className="new-mobile-menu__header-bell">
                  <NotificationBell />
                </div>
              )}
              <button
                className="new-mobile-menu__close"
                onClick={closeMenu}
                aria-label="Close menu"
              >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              >
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
            </div>
          </div>

          <nav className="new-mobile-menu__nav">
            <ul>
              {isAdmin && (
                <li style={{ "--delay": `${menus.length * 0.05 + 0.06}s` }}>
                  <Link
                    to="/admin"
                    className={pathname === "/admin" ? "active" : ""}
                    onClick={closeMenu}
                  >
                    Admin
                  </Link>
                </li>
              )}
              {menus.map((item, i) => (
                <li
                  key={item.id}
                  style={{ "--delay": `${i * 0.05 + 0.06}s` }}
                >
                  <Link
                    to={item.link}
                    className={pathname === item.link ? "active" : ""}
                    onClick={closeMenu}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
              
            </ul>
          </nav>

          <div className="new-mobile-menu__bottom">
            {user?.email ? (
              <button
                className="new-mobile-menu__cta new-mobile-menu__cta--logout"
                onClick={() => { handleLogout(); closeMenu(); }}
              >
                Deconectare
              </button>
            ) : (
              <Link
                to="/login"
                className="new-mobile-menu__cta"
                onClick={closeMenu}
              >
                Autentificare
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, { addUser, emptyCart })(PloomNavbar);
